<div>
  <div class="relative">
    <ng-content></ng-content>
    <div class="absolute align-items-center flex right-0 top-0 p-2 pl-0" [ngClass]="iconStyleClass">
      @if (iconTemplate) {
        <template *ngTemplateOutlet="iconTemplate"></template>
      }
    </div>
  </div>

</div>